<template>
  <div>
      <div class="custom-circle" :class="[getState ? 'is-on' : 'is-off']"></div>
  </div>
</template>

<script>
  export default {
    props: {
      isOn: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {

      }
    },
    computed: {
      getState() {
        return this.isOn;
      }
    }
  }
</script>

<style scoped>
  .custom-circle {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-right: 6px;
  }

  .is-on {
    background-color: #FFC722;
  }

  .is-off {
    background-color: white;
  }

</style>